/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * Creates a third party integrations section
 *
 * @module enervee_utils.third_party_integrations
 */
function thirdPartyIntegrationDirective() {
    return {
        restrict: 'E',
        scope: {
            product: '<?',
            category: '<?',
            extraClasses: '@?',
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: thirdPartyIntegrationController,
        template: require('./thirdPartyIntegrationView.html')
    };
}

thirdPartyIntegrationController.$inject = [
    '$log',
    'AnalyticsService',
    'DisclosuresModalService',
    'UtilService'
];
function thirdPartyIntegrationController (
    $log,
    AnalyticsService,
    DisclosuresModalService,
    UtilService
) {
    this.$onInit = function () {

        let vm = this;

        if (vm.product) {
            vm.category = vm.product.category;
        }

        vm.integrationsSetting = UtilService.getCategoryOrSiteSetting(
            vm.category.id,
            'third_party_integrations',
            []
        );

        vm.showIntegrations = vm.integrationsSetting.length > 0;
    };
}

module.exports = thirdPartyIntegrationDirective;
